
import MoneyRemove from "../../../assets/filled/MoneyRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoneyRemoveIcon({ className, dataTestid = "MoneyRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MoneyRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
